module.exports = __webpack_public_path__ + "static/media/attention.b584c9e6.svg";